// src/components/SeoHead/SeoHead.js
import { useEffect } from "react";

const SeoHead = ({
  title = "Waldir Pianos | Reforma, Venda e Manutenção de Pianos",
  description = "Especialistas em reforma, venda e manutenção de pianos. Tradição e qualidade há décadas. Solicite seu orçamento!",
  keywords = "piano, reforma de piano, venda de piano, manutenção de piano, Waldir Pianos",
  author = "Waldir Pianos",
  image = "/images/logo-social.jpg",
  url = "https://pianoswaldir.com.br/",
  canonicalUrl,
  schemaMarkup,
  facebookAppId,
  twitterHandle = "@waldirpianos",
  type = "website",
  noIndex = false
}) => {
  useEffect(() => {
    // Title
    document.title = title;

    // Meta Tags
    const setMeta = (name, content, property = false) => {
      let element = document.querySelector(
        property ? `meta[property='${name}']` : `meta[name='${name}']`
      );
      
      if (!element) {
        element = document.createElement("meta");
        if (property) {
          element.setAttribute("property", name);
        } else {
          element.setAttribute("name", name);
        }
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    // Basic Meta
    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("author", author);
    setMeta("robots", `${noIndex ? 'noindex' : 'index'},follow`);

    // Open Graph / Facebook
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:image", image, true);
    setMeta("og:url", url, true);
    setMeta("og:type", type, true);

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", image);
    if (twitterHandle) {
      setMeta("twitter:site", twitterHandle);
      setMeta("twitter:creator", twitterHandle);
    }

    // WhatsApp
    setMeta("og:image:width", "1200", true);
    setMeta("og:image:height", "630", true);
    setMeta("og:image:alt", title, true);

    // Canonical URL
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl || url);

    // Schema Markup
    let script = document.querySelector("script[type='application/ld+json']");
    if (schemaMarkup) {
      if (!script) {
        script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schemaMarkup);
    } else if (script) {
      script.remove();
    }

    // Facebook App ID
    if (facebookAppId) {
      setMeta("fb:app_id", facebookAppId, true);
    }

  }, [title, description, keywords, author, image, url, canonicalUrl, schemaMarkup, facebookAppId, twitterHandle, type, noIndex]);

  return null;
};

// Helper para gerar schema de produto
SeoHead.generateProductSchema = (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": `${product.marca} ${product.modelo}`,
  "image": product.foto_principal,
  "description": product.descricao?.replace(/<[^>]*>/g, '').substring(0, 300) || "",
  "brand": {
    "@type": "Brand",
    "name": product.marca
  },
  "offers": {
    "@type": "Offer",
    "url": `https://pianoswaldir.com.br/pianos/${product.id}`,
    "priceCurrency": "BRL",
    "price": product.valor,
    "availability": product.status === 'disponivel' ? 
      "https://schema.org/InStock" : "https://schema.org/OutOfStock",
    "itemCondition": "https://schema.org/UsedCondition"
  }
});

export default SeoHead;